<div class="analysis-panel">
  <div class="panel-header">
    <app-back-button
      [title]="'Yield Analysis' | translate"
      [parentRoute]="'/crop-yield-forecasts'"></app-back-button>
  </div>

  <div class="content-container">
    <div class="content-left">
      <div class="table-wrapper">
        <div
          class="loading-indicator"
          *ngIf="isLoading">
          <p>{{ "Loading..." | translate }}</p>
        </div>

        <h3 class="mb-3">{{ "Analysis History" | translate }}</h3>

        <p-table
          [value]="analysisLogs"
          [scrollable]="true"
          scrollHeight="flex"
          styleClass="p-datatable-gridlines custom-table"
          [tableStyle]="{ 'min-width': '85rem' }">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ "Started" | translate }}</th>
              <th style="width: 200px">{{ "User" | translate }}</th>
              <th style="width: 300px">{{ "Region" | translate }}</th>
              <th>{{ "Finished" | translate }}</th>
              <th class="text-right">{{ "Total" | translate }}</th>
              <th class="text-right">{{ "Success" | translate }}</th>
              <th class="text-right">{{ "Errors" | translate }}</th>
              <th class="text-center">{{ "Status" | translate }}</th>
              <th class="text-center">{{ "Details" | translate }}</th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-log>
            <tr>
              <td>
                {{ log.startedAt || log.createAt | date: "dd.MM.yyyy HH:mm" }}
              </td>

              <td>{{ getUserName(log.createUser) }}</td>

              <td>{{ getRegionName(log.regionId) }}</td>

              <td>
                {{ (log.finishedAt | date: "dd.MM.yyyy HH:mm") || "-" }}
              </td>

              <td class="text-right">
                {{ log.totalSeasonsFound || 0 }}
              </td>

              <td class="text-right">
                <span [class.text-success]="log.successfullyProcessedCount > 0">
                  {{ log.successfullyProcessedCount || 0 }}
                </span>
              </td>

              <td class="text-right">
                <span [class.text-danger]="log.errorCount > 0">
                  {{ log.errorCount || 0 }}
                </span>
              </td>

              <td class="text-center">
                <span
                  class="status-badge"
                  [ngClass]="getBadgeClass(log.calculationStatus)">
                  {{ log.calculationStatus | translate }}
                </span>
              </td>
              <td class="text-center">
                <button
                  pButton
                  type="button"
                  icon="pi pi-info-circle"
                  class="p-button-rounded p-button-text p-button-secondary"
                  [disabled]="!log.errorDetails"
                  (click)="showErrorDetails(log.errorDetails)"></button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td
                colspan="9"
                class="text-center p-4">
                {{ "No analysis history found" | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div
          class="mt-3"
          *ngIf="totalCount > 0">
          <app-custom-paginator
            [first]="first"
            [pageSize]="pageSize"
            [totalRecords]="totalCount"
            (pageChange)="onPageChange($event)"
            (pageSizeChange)="onPageSizeChange($event)"></app-custom-paginator>
        </div>
      </div>
    </div>

    <div class="sidebar-right">
      <div class="controls-card-sidebar">
        <h3
          class="mb-3"
          style="font-size: 18px; font-weight: 600">
          {{ "Settings" | translate }}
        </h3>

        <div class="form-group region-select">
          <app-region-tree-select
            [regions]="regions"
            [selectedRegionId]="selectedRegionId"
            (regionSelected)="onRegionSelected($event)"></app-region-tree-select>
        </div>

        <div class="action-buttons mt-4">
          <button
            pButton
            type="button"
            [label]="'Get Yield Analysis' | translate"
            class="p-button-primary"
            style="width: 100%"
            [disabled]="!selectedRegionId || isLoading"
            [loading]="isLoading"
            (click)="runAnalysis()"></button>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [header]="'Error Details' | translate"
  [(visible)]="displayErrorDialog"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true">
  <div class="error-log-content">
    <pre>{{ selectedErrorDetails }}</pre>
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      [label]="'Close' | translate"
      (click)="displayErrorDialog = false"
      class="p-button-text"></button>
  </ng-template>
</p-dialog>
